import React from 'react';
import { BudgetRecipientEnum } from '../../../createAndEdit/types';
import { Budget } from '../../../types';
import { formatRecipientLabel } from '../../../utils';
import StatusBadge from '../StatusBadge';
import ViewBudgetButton from '../ViewBudgetButton';
import { useBudgetNavigation } from '../../hooks/useBudgetNavigation';

interface IBudgetRowProps {
  budget: Budget;
  hasHistory: boolean;
  onViewHistory: (budgetId: string) => void;
  onViewBudget: (budgetId: string, versionNumber?: number) => void;
  onEditBudget?: (budgetId: string, versionNumber?: number) => void;
  userProfile?: BudgetRecipientEnum | string;
}

const BudgetRow = (props: IBudgetRowProps) => {
  const { handleBudgetClick } = useBudgetNavigation({
    budget: props.budget,
    userProfile: props.userProfile,
    onViewBudget: props.onViewBudget,
    onEditBudget: props.onEditBudget,
  });

  return (
    <tr>
      <td style={{ maxWidth: '180px', width: '180px' }}>
        <div style={{ wordBreak: 'break-word', whiteSpace: 'normal' }}>
          {props.budget.consultantName}
        </div>
      </td>
      <td style={{ maxWidth: '200px', width: '200px' }}>
        <div style={{ wordBreak: 'break-word', whiteSpace: 'normal' }}>
          {props.budget.originUserName ?? 'Não identificado'} ({formatRecipientLabel(props.budget.origin)})
        </div>
      </td>
      <td>{formatRecipientLabel(props.budget.recipient)}</td>
      <td>{props.budget.user}</td>
      <td>
        <ViewBudgetButton onClick={handleBudgetClick} />
      </td>
      <td style={{ maxWidth: '80px', width: '80px' }}>{props.budget.version}</td>
      <td>{props.budget.date}</td>
      <td>
        <StatusBadge status={props.budget.status} />
      </td>
      <td onClick={(e) => e.stopPropagation()}>
        {props.hasHistory && (
          <button
            type="button"
            className="text-blue-600 hover:text-blue-800 underline text-size-14 cursor-pointer border-0 bg-transparent p-0"
            onClick={() => props.onViewHistory(props.budget.id)}
            aria-label="Visualizar histórico"
          >
            Visualizar histórico
          </button>
        )}
      </td>
    </tr>
  );
};

export default BudgetRow;

